(() => {
  const selector = 'form[data-pcstation-search-submit]';
  const submit = (form, event) => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    event.preventDefault();
    const term = input.value.trim();
    if (!term) {
      input.focus();
      return;
    }
    const url = new URL(form.action, window.location.href);
    const params = new URLSearchParams(new FormData(form));
    params.set('q', term);
    params.set('type', 'product');
    if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
    const current = new URLSearchParams(window.location.search);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.has(key)) params.set(key, current.get(key));
    }
    url.search = params.toString();
    window.location.assign(url.href);
  };
  document.addEventListener('submit', (event) => {
    if (event.target.matches(selector)) submit(event.target, event);
  }, true);
  const request = (form, event, button) => {
    event.preventDefault();
    if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[type="submit"]');
    if (button?.form?.matches(selector)) request(button.form, event, button);
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing || !event.target.matches('input[name="q"]')) return;
    const form = event.target.form;
    if (form?.matches(selector)) request(form, event, form.querySelector('button[type="submit"]') || undefined);
  }, true);
})();
